import styled from '@emotion/styled';

import { Gray_Light_300, Pink_Light_400 } from '@common/styles';

export const Root = styled.p`
  display: flex;
  align-items: center;

  .discount-type {
    color: ${Pink_Light_400};
    margin-right: 2px;
    font-weight: 700;
  }

  .original-price {
    color: ${Gray_Light_300};
    text-decoration: line-through;
  }
`;
